import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { ProblemDetails, ProblemCause, ProblemAction, ProblemComment, ProposedAction } from '../../shared/problem-details'
import { Deparment,RespPerson, GenResponse } from '../../shared/misc-classes'

import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';
@Component({
  selector: 'bs-day-view',
  templateUrl: './bs-day-view.component.html',
  styleUrls: ['./bs-day-view.component.css']
})
export class BSDayViewComponent implements OnInit {
  problemDetails:Array<ProblemDetails> = []
  selProblemIndex:number = -1;
  currSelDate:Date = new Date();
  defProblemId:string = '';
  propActionCounter:Array<number> = [1,2,3,4,5,6,7,8,9,10];
  
  public options = {
    position: ["top", "left"],
    timeOut: 5000,
    lastOnBottom: true
  }

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editDate:Date;
  editAction:ProblemAction = null;
  editParam1:any;

  problemId:Array<any>;
  selectedPrblm:number = -1;
  selProblem:any;
  moduleId:string = "358c4a3a-a090-d159-a799-c6d5eed75626";
  mId:string ="";
  @ViewChild('childModal') public childModal:ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;
  
  constructor(public _dataService:DataService, private activatedRoute:ActivatedRoute, 
              private _notify:NotificationsService) {
              }

  ngOnInit() {
    //access checking here
    

    this.activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['id']){
        this.defProblemId = params['id'];  
      }
      else{
        this.defProblemId = '';
      }
      if(params['date']){
        this.currSelDate = new Date(params['date']);
      }
      this.loadBSProblem(this.defProblemId, this.currSelDate);
    });
    
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }

  loadBSProblem(_id:string,_selDate:Date){
    this._dataService.loadProblemsForDay(_id,new Date(_selDate.getFullYear(),_selDate.getMonth(),_selDate.getDate())).subscribe((_probs:Array<ProblemDetails>) => {
        this.drawProblemDetails(_probs);
    });
  }
  getCurrSelDateStr(){
    return GenService.getDateFormatStr(this.currSelDate, "DD MMM YYYY")
  }
  drawProblemDetails(_probs:Array<ProblemDetails>){
    // console.log(_probs)
    if(_probs.length > 0 ){
      //this.currSelDate = _probs[0].startDateObj;
      this.problemDetails =  _probs;
      if(this.defProblemId != ''){
        for(var i=0;i<this.problemDetails.length;i++){
          if(this.problemDetails[i].id == this.defProblemId){
            this.selProblemIndex = i;
            return;
          }
        }
      }
      this.selProblemIndex = 0;
    }
    else{
      this.problemDetails =  _probs;
      this.selProblemIndex = -1;
    }
  }
  formatEndDate(_date:any):string{
    if(_date && _date > 0){
      return GenService.getDateFormatStr(new Date(_date), "DD-MM-YYYY");
    }
    return '-';
  }
  formatStartDate(_date:any):string{
    if(_date && _date > 0){
      return GenService.getDateFormatStr(new Date(_date), "DD-MMM-YYYY");
    }
    return '-';
  }
  formatCommentTime(_date:any):string{
    if(_date && _date > 0){
      return GenService.getDateFormatStr(new Date(_date), "DD/MMM/YY HH:mm:ss");
    }
    return '';
  }
  formatActionTargetDate(_date:any):string{
    if(_date && _date > 0){
      return GenService.getDateFormatStr(new Date(_date), "DD-MMM-YYYY");
    }
    return '-';
  }
  problemClicked(e,i){
    this.selProblemIndex = i;
        //this.selectedPrblm = i;
        //this.selProblem = this.problemId[this.selectedPrblm];
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  enterDetails(){

  }
  public showChildModal(_editToken:string,_param1:any):void {
    switch(_editToken){
      case "current_date":
        this.editDate = new Date(this.currSelDate.getTime());// GenService.getDateFormatStr(this.currSelDate, "DD-MM-YYYY"));
        this.editType = 'date';
        this.editHeader = "Edit Start Date";
      break;
      case "problem":
        this.editText = this.problemDetails[this.selProblemIndex].header;
        this.editType = 'multitext';
        this.editHeader = "Edit Problem";
      break;
      case "end_date":
        this.editDate =  this.problemDetails[this.selProblemIndex].endDateObj;
        this.editType = 'date';
        this.editHeader = "Edit End Date";
      break;
      case "description":
        this.editText =  this.problemDetails[this.selProblemIndex].description;
        this.editType = 'multitext';
        this.editHeader = "Edit Description";
      break;
      case "addcomment":
        this.editText =  '';
        this.editType = 'multitext';
        this.editHeader = "Add Comment";
      break;
      case 'root_cause':
        this.editText =  this.problemDetails[this.selProblemIndex].rootCause;
        this.editType = 'multitext';
        this.editHeader = "Edit Root Cause";
      break;
      case 'man':case 'material':case 'method':case 'machine':case 'environment':
        let _index:number = this.problemDetails[this.selProblemIndex].causes.findIndex((_pCause:ProblemCause) => {
            return _pCause.typeofCategory == _editToken;
        });
        if(_index < 0){
            this.problemDetails[this.selProblemIndex].causes.push(new ProblemCause(_editToken,'',null,true));
            _index = this.problemDetails[this.selProblemIndex].causes.length - 1;
        }
        this.editText = this.problemDetails[this.selProblemIndex].causes[_index].details;
        this.editType = 'multitext';
        this.editHeader = "Edit Cause (" + this._dataService.getRCCatName(_editToken) + ")";
      break;
      case 'proposed_action':
        this.editText =  this.problemDetails[this.selProblemIndex].proposedAction;
        this.editType = 'multitext';
        this.editHeader = "Edit Proposed Action";
      break;
      case 'propaction_item':
     //    let tmpPA:ProblemAction = this.problemDetails[this.selProblemIndex].actions[_param1];
         if(_param1 == null){
          this.editAction = new ProblemAction(null,null,null,new Date().getTime(),null);
         }else{
          let tmpPA:ProblemAction = this.problemDetails[this.selProblemIndex].actions[_param1];
          this.editAction = new ProblemAction(tmpPA.propAction,tmpPA.function,tmpPA.responsible,tmpPA.targetTimeObj.getTime(),tmpPA.log_doc);
         }
        
         this.editParam1 = _param1;
         this.editType = 'propactionitem';
         this.editHeader = "Edit Action";
      break;
      case 'status':
        this.editText =  this.problemDetails[this.selProblemIndex].status;
        this.editType = 'status';
        this.editHeader = "Edit Status";
      break;
    }
    this.editToken = _editToken;
    this.childModal.show();
  }

  dataEdited(){
    switch(this.editToken){
      case "current_date":
        this.currSelDate =  this.editDate;
        this.defProblemId = "";
        this.loadBSProblem(this.defProblemId,this.currSelDate);
      break;
      case "problem":
        //validate where required
        this.problemDetails[this.selProblemIndex].header = this.editText;
      break;
       case "end_date":
        this.problemDetails[this.selProblemIndex].endDate = (this.editDate).getTime()
        //console.log(this.editDate);
      break;
      case "description":
        this.problemDetails[this.selProblemIndex].description = this.editText;
      break;
      case "addcomment":
        this.problemDetails[this.selProblemIndex].comments.push(new ProblemComment(this.editText,(new Date()).getTime(),this._dataService.userId,"active"));
      break;
      case "root_cause":
        this.problemDetails[this.selProblemIndex].rootCause = this.editText;
      break;
      case 'man':case 'material':case 'method':case 'machine':case 'environment':
        let _index:number = this.problemDetails[this.selProblemIndex].causes.findIndex((_pCause:ProblemCause) => {
            return _pCause.typeofCategory == this.editToken;
        });
        if(_index >= 0){
          this.problemDetails[this.selProblemIndex].causes[_index].details = this.editText;
        }
      break;
      case 'proposed_action':
        this.problemDetails[this.selProblemIndex].proposedAction = this.editText;
      break;
      case 'propaction_item':
      if(this.editParam1 == null){
        this.problemDetails[this.selProblemIndex].addProposedAction(new ProblemAction(this.editAction.propAction,this.editAction.function,this.editAction.responsible,this.editAction.targetTimeObj.getTime(),null))
      }
      else{
        this.problemDetails[this.selProblemIndex].actions[this.editParam1].propAction = this.editAction.propAction;
          this.problemDetails[this.selProblemIndex].actions[this.editParam1].function = this.editAction.function;
          this.problemDetails[this.selProblemIndex].actions[this.editParam1].responsible = this.editAction.responsible;
          this.problemDetails[this.selProblemIndex].actions[this.editParam1].targetTimeObj = this.editAction.targetTimeObj;
      }       
          
      break;
      case 'status':
          if(this.problemDetails[this.selProblemIndex].status == 'open' &&
          this.editText == 'close'){
            this.problemDetails[this.selProblemIndex].endDate = (new Date()).getTime();
          }

          this.problemDetails[this.selProblemIndex].status = this.editText;
          
      break;

    }

    this.hideChildModal();
  }

  rcCategoryClick(_catRef:string){
      if(this.selProblemIndex >= 0){
          let _displayModal:boolean = false;
          let _tmpCause:ProblemCause = this.problemDetails[this.selProblemIndex].causes.find((_probCause:ProblemCause) => {
            return _probCause.typeofCategory == _catRef;
          });
          if(_tmpCause){
            if(_tmpCause.isEnabled == true)
                _tmpCause.isEnabled = false;
            else {
                _tmpCause.isEnabled = true;
                _displayModal = true;
            }
          } 
          else{
              this.problemDetails[this.selProblemIndex].addCause(new ProblemCause(_catRef,'','',true));
              _displayModal = true;
          }
          if(_displayModal == true){
              this.showChildModal(_catRef,null);
          }
      }
  }
  getRCCatStatusCss(_catRef:string):string{
    if(this.selProblemIndex >= 0){
      let _tmpCause:ProblemCause = this.problemDetails[this.selProblemIndex].causes.find((_probCause:ProblemCause) => {
        return _probCause.typeofCategory == _catRef;
      });
      if(_tmpCause)
      if(_tmpCause && (_tmpCause.isEnabled == true)){
        return 'cat-remove fa-minus';
      }
      return 'cat-add fa-plus';
    }
    return '';
  }

  addNewPropAction(){
    //problemDetails[selProblemIndex].actions
    if(this.selProblemIndex >= 0){
      //let actionCount:number = this.problemDetails[this.selProblemIndex].addProposedAction(new ProblemAction('-',null,null,(new Date()).getTime(),null));
      this.showChildModal('propaction_item', null);
    }
  }

  removeActionDecided(_actionIndex:number){
    if(this.selProblemIndex >= 0){
      this.problemDetails[this.selProblemIndex].removeProposedAction(_actionIndex);
    }
  }
  discardChanges(){
    this.loadBSProblem(this.defProblemId,this.currSelDate);
  }
  saveProblemData(_sendMail:boolean){
    if(this.selProblemIndex >= 0){
      this._dataService.saveBrainStormProblem(this.problemDetails[this.selProblemIndex],_sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status == "FAIL"){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", resp.details)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          //save success
          this.defProblemId = resp.docId;
          this.loadBSProblem(this.defProblemId,this.currSelDate);
          this._notify.success('Success','Data Saved.',this._dataService.successOptions);
        }

      });
    }
    
  }

  getFunctionStr(_funcId:string):string{
    if(_funcId){
        let tmpDeptRef:Deparment = this._dataService.departments.find((_tmpDept:Deparment) => {
          return _tmpDept.depId == _funcId;
        });
        if(tmpDeptRef){
          return tmpDeptRef.depName;
        }
    }
    return '-';
  }
  getRespPersonStr(_respPerId:string):string{
    if(_respPerId){
      let tmpRespRef:RespPerson = this._dataService.respPersons.find((_tmpResp:RespPerson) => {
          return _tmpResp.respId == _respPerId;
        });
        if(tmpRespRef){
          return tmpRespRef.respName;
        }
    }
    return '-'
  }

  addNewProblem():void{
   this.problemDetails.push(new ProblemDetails("","","",null,null,"",[],"",[],[],"open",null));
   this.selProblemIndex = this.problemDetails.length-1;    
   this.problemDetails[this.selProblemIndex].startDate = (new Date()).getTime();
    this.showChildModal('problem',null);
  }
 
  public hideChildModal():void {
    switch(this.editToken){
      case "problem":
        if(this.problemDetails[this.selProblemIndex].header.length == 0 ){
          this.problemDetails.splice(this.selProblemIndex,1);
          this.selProblemIndex = this.problemDetails.length-1;
        }
      break;
      case 'man':case 'material':case 'method':case 'machine':case 'environment':
      let causelength;
      let _index:number = this.problemDetails[this.selProblemIndex].causes.findIndex((_pCause:ProblemCause) => {
           causelength = _pCause.details.length;
          return _pCause.typeofCategory == this.editToken;
      });
      if(causelength == 0){
        this.problemDetails[this.selProblemIndex].causes.splice(_index,1);
      }
      break;
      case 'propaction_item':        
      // let actionlength;
      // let _idex:number = this.problemDetails[this.selProblemIndex].actions.findIndex((_pCause:ProblemAction) => {
      //     actionlength = _pCause.propAction.length;
      //     return actionlength == this.editParam1;
      // });
      // if(actionlength == 0){
      //   this.problemDetails[this.selProblemIndex].actions.splice(_idex,1);
      // }
      break;
    }  
    this.childModal.hide();
  }
}
